import React from 'react';
import { Carousel } from 'antd';
import { Row, Col } from 'antd';
import ColumnHeader from './ColumnHeader';
import JadwalDokter from './JadwalDokter';
import Title from './Title';
import {
    infoKamarColumn,
    JadwalDokterColumn,
    //JadwalDokterColumn2,
    urlKamar,
    urlJadwal,
    infoKamarColumnTipe1
} from '../config';
import InfoKamar from './InfoKamar';
import { request } from './service';
import {
    setInfoKamar,
} from '../localstorage/config';
import MyModalError from './MyModalError';
import EmptyData from './EmptyData';
//import { judulinformasi } from '../style';

const initialState = {
    tipe: 1,
    modal_error: false,
    isJadwalChecked: true,
    isKamarChecked: true,
    caro_key: Date.now(),
    panel_setting: false,
    active_slide: 'tt',
    show_order: ['tt'],
    data_on_slide: [],
    ukuranFont: 36,
    kelas: '-',
    title: 'Pesan Error',
    content: 'Koneksi Gagal!',
    data:
    {
        tt: {
            title: 'INFORMASI TEMPAT TIDUR',
            key: 'tt',
            autoplaySpeed: 7000,
            urlData: urlKamar,
            tipe: 1
        },
        jd: {
            title: 'JADWAL DOKTER',
            key: 'jd',
            autoplaySpeed: 7000,
            urlData: urlJadwal,
            tipe: 1
        }
    }
};

class MyCarousel extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = initialState;
    }

    componentDidMount() {
        this.setConfigApp();
    }

    fetchFirst = async () => {
        let active = this.state.active_slide;
        let urlStart = this.state.data[active].urlData;
        var data = await request(urlStart);
        console.log(data);
        if (data.status !== 'error') {
            this.setState({
                tipe: data.tipe,
                data_on_slide: data.list
            })

            if(data.list.length == 0){
                this.setState({
                    title: 'Informasi',
                    content: 'Data tidak ditemukan.'
                })
                this.showError()
            }
            return
        }
        this.showError();
    }

    showError = () => {
        this.setState({
            panel_setting: false,
            modal_error: true
        });
    }

    fetchData = async (urlData) => {
        const res = await request(urlData);

        if (res.status === 'error') {
            this.showError();
        }

        if(res.list.length == 0){
            this.setState({
                title: 'Informasi',
                content: 'Data tidak ditemukan.'
            })
            this.showError()
        }

        return res.list;
    }

    setLokalInfoKamar = async (val) => {
        var setStatus = await setInfoKamar(val.list);
        if (setStatus) {
            return true;
        }
    }

    setConfigApp = () => {
        let configApp = JSON.parse(localStorage.getItem('configApp'));

        if (configApp !== null) {
            this.setState(configApp,
                () => this.fetchFirst());
        } else {
            this.setDefaultConfig();
            this.fetchFirst();
        }
    }

    setDefaultConfig = () => {
        const defaultConfigApp = initialState;

        localStorage.setItem('configApp', JSON.stringify(defaultConfigApp));
    }

    genColumnHeader = (tipe) => {
        let ch;
        if (tipe === 2) {
            ch = infoKamarColumn;
        } else if (tipe === 1) {
            ch = infoKamarColumnTipe1;
        }
        return <ColumnHeader data={ch} />
    }

    afterChange = async (current) => {
        var slides = this.state.data_on_slide;

        var next_slide = this.goToNextOrder(this.state.active_slide);

        var slideInfo = {
            current: current,
            total: slides.length,
            aktive_slide: this.state.active_slide,
            next_active_slide: next_slide,
            config_slide: this.state.data[this.state.active_slide]
        };

        if (current + 1 === slideInfo.total) {

            var data = await request(this.state.data[next_slide].urlData);

            if (data.status === 'error') {
                this.setState({
                    panel_setting: false,
                    modal_error: true
                });
            } else {
                this.setState({
                    modal_error: false,
                    //caro_key: Date.now(),
                    active_slide: slideInfo.next_active_slide,
                    tipe: data.tipe,
                    data_on_slide: data.list
                });
            }
        }
    }

    beforeChange = (from, to) => {
        var slides = this.state.data_on_slide;
        let kelas = typeof slides[to] === "undefined" ? "-" : slides[to][0].nama_kelas;
        if (slides.length > 0) {
            if (to === slides.length) {
                kelas = slides[0][0].nama_kelas
            }
        }
        this.setState({
            kelas: kelas
        });
    }

    goToNextOrder = (value) => {
        var totalLength = this.state.show_order.length;
        var now = this.getPositionOrder(value);

        if (totalLength - 1 === now) {
            return this.state.show_order[0];
        }

        return this.state.show_order[now + 1];
    }

    onInitCaro = () => {
        var slides = this.state.data_on_slide;
        let initkelas = typeof slides[0] === "undefined" ? "-" : slides[0][0].nama_kelas;
        this.setState({
            kelas: initkelas
        });
    }

    getPositionOrder = (value) => {
        var listOrder = this.state.show_order;
        var index = listOrder.indexOf(value);

        return index;
    }

    OnOkModalError = () => {
        this.setState({
            modal_error: false
        });
    }
    render() {
        const currentAktiv = this.state.active_slide;
        const judul = this.state.data[currentAktiv].title;
        return <Col>
            <Row type="flex" justify="center">
                <Title text={judul} />
            </Row>
            {/* <Row>
                <div style={{
                    fontWeight: 'bold',
                    margin: 5,
                    visibility: (currentAktiv === 'tt') && (this.state.tipe === 2) ? '' : 'hidden'
                }}>Kelas Kamar : Kelas {this.state.kelas}</div>
            </Row> */}
            <Row>
                <Col>
                    <Row>
                        {
                            this.state.active_slide === 'tt' ? this.genColumnHeader(this.state.tipe) : <ColumnHeader
                                data={JadwalDokterColumn}
                            />
                        }
                    </Row>
                    <Row>
                        {
                            this.state.data_on_slide.length == 0 ?
                                <EmptyData /> :
                                <Carousel
                                    key={this.state.caro_key}
                                    ref={slider => (this.slider = slider)}
                                    autoplay
                                    afterChange={this.afterChange}
                                    beforeChange={this.beforeChange}
                                    fade={true}
                                    speed={1000}
                                    slidesToScroll={1}
                                    slidesToShow={1}
                                    onInit={this.onInitCaro}
                                    autoplaySpeed={this.state.data[currentAktiv].autoplaySpeed}>
                                    {
                                        this.state.data_on_slide.map((val, i) => {
                                            return this.state.active_slide === 'tt' ?
                                                <InfoKamar
                                                    tipe={this.state.tipe}
                                                    fontSize={this.state.ukuranFont}
                                                    key={"row_" + i} data={val} /> :
                                                <JadwalDokter
                                                    fontSize={this.state.ukuranFont}
                                                    key={"row_" + i}
                                                    data={val} />
                                        })
                                    }
                                </Carousel >

                        }
                    </Row>
                </Col>
            </Row>
            {
                this.state.modal_error ? <MyModalError
                    title={this.state.title}
                    content={this.state.content}
                    visible={this.state.modal_error}
                    onOk={this.OnOkModalError}
                    onCancel={this.OnOkModalError}
                    onAction={this.fetchFirst}
                /> : <div></div>
            }
        </Col>
    }
}

export default MyCarousel;